import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PdfChangeRequestViewRoutingModule } from './pdf-change-request-view-routing.module';
import { PdfChangeRequestViewComponent } from './pdf-change-request-view.component';
import { PDFModule } from 'app/pdf/pdf.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { I18nModule } from 'app/shared/i18n/i18n.module';

@NgModule({
  imports: [
    CommonModule,
    PdfChangeRequestViewRoutingModule,
    PDFModule,
    NgxSpinnerModule,
    I18nModule
  ],
  declarations: [PdfChangeRequestViewComponent]
})
export class PdfChangeRequestViewModule { }
